import { action } from 'satcheljs';
import { TxpEventFlags } from '../store/schema/TxpGriffinSettingsPayload';

/**
 * Sets the flag for a specific txp setting type in the store
 */
type TxpStateFlags = 'CreateEventsFromEmailAsPrivate';

export const updateTxpSettingFlag = action(
    'updateTxpSettingFlag',
    (flagName: TxpStateFlags | TxpEventFlags, enabled?: boolean, value?: number) => ({
        flagName: flagName,
        enabled: enabled,
        value: value,
    })
);
